import { useState, useEffect } from "react";
import { SEARCH_DEBOUNCE_MS } from "@/constants";

export { SEARCH_DEBOUNCE_MS };

/**
 * Returns a debounced version of the given value.
 * Updates are delayed by `delay` ms after the value stops changing.
 * Useful for search inputs to reduce API calls while typing.
 */
export function useDebouncedValue<T>(value: T, delay: number = SEARCH_DEBOUNCE_MS): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
